import { FC } from "react";
import { Text, Line, Circle } from "react-konva";
import houseModelConfig from "utils/houseModelConfig";
import paperSize from "utils/paperSize";

type TSecondGoalsProps = {
  text?: string;
};

const fontSize = houseModelConfig.fontSize;
const lineHeight = houseModelConfig.lineHeight;
const textColor = houseModelConfig.colorGlobals[1];
const guildeCircleSize = 2;
const guildeLineColor = houseModelConfig.colorGlobals[1];
const x = 10;
const y = (paperSize.height * 70) / 100;
const w = paperSize.width / 5.5;
const h = fontSize * lineHeight * 13;
const guildePoints = [
  (paperSize.width * 36) / 100,
  (paperSize.height * 65) / 100,
  x + w + 30,
  (paperSize.height * 65) / 100,
  x + w + 10,
  y + fontSize / 2,
];

const SecondGoals: FC<TSecondGoalsProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <>
      <Circle
        x={guildePoints[0]}
        y={guildePoints[1]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Circle
        x={guildePoints[4]}
        y={guildePoints[5]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Line
        points={guildePoints}
        stroke={guildeLineColor}
        strokeWidth={1}
        lineJoin="round"
        dash={[3, 2]}
      />
      <Text
        x={x}
        y={y}
        width={w}
        height={h}
        align="right"
        fontSize={fontSize}
        lineHeight={lineHeight}
        text={text}
        fill={textColor}
      />
    </>
  );
};

export default SecondGoals;
